import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={onClose} data-id="element-295">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-296">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 sticky top-0 bg-white rounded-t-xl" data-id="element-297">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-298">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-299">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-300" />
          </button>
        </div>
        <div className="p-6" data-id="element-301">{children}</div>
      </div>
    </div>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-gray-900 py-8" data-id="element-302">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-303">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-304">
            <p className="text-gray-400 text-sm" data-id="element-305">
              © {new Date().getFullYear()} Amigos Peludos. Todos los derechos
              reservados.
            </p>
            <div className="flex gap-6" data-id="element-306">
              <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-307">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-308">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-309">
        <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-310">
          <p className="text-sm text-gray-500" data-id="element-311">
            Última actualización: Abril 2026
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-312">
            1. Información que recopilamos
          </h3>
          <p data-id="element-313">
            Recopilamos información personal que nos proporcionás
            voluntariamente al realizar una compra, como tu nombre, dirección de
            correo electrónico y datos de pago. También recopilamos datos de
            navegación de forma automática mediante cookies y tecnologías
            similares.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-314">
            2. Uso de la información
          </h3>
          <p data-id="element-315">
            Utilizamos tu información para procesar tu compra, enviarte el
            producto digital adquirido, mejorar nuestros servicios y, si diste
            tu consentimiento, enviarte comunicaciones de marketing relacionadas
            con nuestros productos.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-316">
            3. Protección de datos
          </h3>
          <p data-id="element-317">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            alteración, divulgación o destrucción.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-318">
            4. Cookies y seguimiento
          </h3>
          <p data-id="element-319">
            Utilizamos cookies y píxeles de seguimiento (como Meta Pixel) para
            analizar el tráfico del sitio y medir la efectividad de nuestras
            campañas publicitarias. Podés configurar tu navegador para rechazar
            cookies, aunque esto podría afectar la funcionalidad del sitio.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-320">
            5. Tus derechos
          </h3>
          <p data-id="element-321">
            Tenés derecho a acceder, rectificar o eliminar tus datos personales
            en cualquier momento. También podés solicitar la limitación del
            tratamiento o la portabilidad de tus datos.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-322">
            6. Cambios en esta política
          </h3>
          <p data-id="element-323">
            Nos reservamos el derecho de actualizar esta política de privacidad
            en cualquier momento. Los cambios serán publicados en esta página
            con la fecha de actualización correspondiente.
          </p>
        </div>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-324">
        <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-325">
          <p className="text-sm text-gray-500" data-id="element-326">
            Última actualización: Abril 2026
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-327">
            1. Aceptación de los términos
          </h3>
          <p data-id="element-328">
            Al acceder y utilizar este sitio web y adquirir nuestros productos
            digitales, aceptás estos términos y condiciones en su totalidad. Si
            no estás de acuerdo con alguna parte, te pedimos que no utilices
            nuestros servicios.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-329">
            2. Producto digital
          </h3>
          <p data-id="element-330">
            "Mascota Sola: Guía Anti-Destrucción" es un producto digital en
            formato PDF. Al completar la compra, recibirás acceso inmediato al
            material. El contenido es informativo y educativo, y no reemplaza la
            consulta con un veterinario o etólogo profesional.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-331">
            3. Propiedad intelectual
          </h3>
          <p data-id="element-332">
            Todo el contenido de la guía, incluyendo textos, imágenes y diseño,
            es propiedad exclusiva de Amigos Peludos. Queda prohibida su
            reproducción, distribución o reventa sin autorización expresa por
            escrito.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-333">
            4. Política de reembolso
          </h3>
          <p data-id="element-334">
            Dado que se trata de un producto digital con acceso inmediato, no se
            realizan reembolsos una vez completada la descarga. Si experimentás
            problemas técnicos para acceder al material, nos comprometemos a
            resolverlos.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-335">
            5. Limitación de responsabilidad
          </h3>
          <p data-id="element-336">
            Los resultados pueden variar según cada mascota y la consistencia en
            la aplicación del método. No garantizamos resultados específicos. En
            casos de comportamiento agresivo o problemas de salud, consultá con
            un profesional veterinario.
          </p>

          <h3 className="text-lg font-semibold text-gray-900" data-id="element-337">
            6. Legislación aplicable
          </h3>
          <p data-id="element-338">
            Estos términos se rigen por las leyes de la República Argentina.
            Cualquier disputa será sometida a la jurisdicción de los tribunales
            competentes de la Ciudad Autónoma de Buenos Aires.
          </p>
        </div>
      </Modal>
    </>;
}